module.exports = __webpack_public_path__ + "img/arrow-down-white.060958a8.svg";